import Paper from '@material-ui/core/Paper';
import { Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import UserDetailsHeader from './UserDetailsHeader';
import UserRolesListItem from './UserRolesListItem';
import UsersContext from './UsersContext';


const width = 948;
const Container = styled.div`
    min-height: 200px;
`;

const UserDetails = props =>
    <UsersContext.Consumer>
        {context =>
            <Formik
                enableReinitialize
                initialValues={{ ...context.users.selectedUserDetails }}
                onSubmit={(values, { setSubmitting }) => {
                    context.saveUserDetails(values, () => {
                        context.cancelEditingUserDetails();
                        setSubmitting(false);
                    });

                }}
            >
                {formProps =>
                    <Paper>
                        <Container>
                            <UserDetailsHeader formProps={formProps} />
                            {context.users.selectedUserDetails &&
                                context.users.selectedUserDetails.approvalRoles.map((role, index) => <UserRolesListItem key={index} role={role} />)
                            }
                        </Container>
                    </Paper>
                }
            </Formik>

        }
    </UsersContext.Consumer>

export default UserDetails;

